document.addEventListener('click', e => {
  if (e.target.matches('.gallery__image')) {
    document
      .querySelector(`.modal[data-modal="${e.target.dataset.modalId}"]`)
      .classList.add('modal--active');
  }
  
  if (e.target.matches('.modal__close') || e.target.matches('.modal__overlay')) {
    e.target.closest('.modal--active').classList.remove('modal--active');
  }
});
